// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"296":"ea88be26","4814":"70cfe1b1"}[chunkId] || chunkId) + "." + {"296":"d7a0e26b59906e3b","4032":"299880f05b84ce76","4814":"87e4459ad8c0701a","7229":"28a8348db387ae40","9464":"9b2406e79ab4eb44"}[chunkId] + ".js";
};